import { CollideEvent, CollideId } from '../../defs/collide';
import {
  CandyBlockEntity,
  despawnBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { InvalidEffect } from '../effects/InvalidEffect';
import { StarGlareEffect } from '../effects/StarGlareEffect';
import { CollideHandler, ICollision } from './ICollision';

/*
    candy block collision resolver
*/
export class CandyCollision implements ICollision {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _entity: CandyBlockEntity;
  // map
  private readonly _resolvers: { [key in CollideId]?: CollideHandler } = {
    tap: this._resolveTap,
    block: this._resolveBlock,
    attack: this._resolveAttack,
  };

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, entity: CandyBlockEntity) {
    this._scene = scene;
    this._entity = entity;
  }

  // impl
  //-------------------------------------------------------------------------
  public async resolve(event: CollideEvent): Promise<boolean> {
    return this._resolvers[event.id]?.call(this, event) ?? false;
  }

  // private: resolvers
  //-------------------------------------------------------------------------
  private async _resolveTap() {
    // invalid effect
    await new InvalidEffect(this._entity).execute();
    return false;
  }

  private async _resolveBlock() {
    this._attack();
    return true;
  }

  private async _resolveAttack() {
    this._attack();
    return true;
  }

  // private: actions
  //-------------------------------------------------------------------------
  private async _attack() {
    const position = this._entity.c.position.mapPosition;

    // destroy the candy
    despawnBlockEntity(this._scene, this._entity);

    return new StarGlareEffect(this._scene, { position }).execute();
  }
}
